import { theme } from "antd";
import { useAuthContext } from "../contexts/auth/useAuthContext";

export const ContactPage = () => {
  const { user } = useAuthContext();
  const { token } = theme.useToken();

  if (!user) {
    return null;
  }

  return (
    <iframe
      src={`https://tally.so/r/mD70qb?embed=1&allowfullscreen=1&email=${user.email}&name=${user.name}`}
      width="100%"
      height="100%"
      style={{
        border: "none",
        boxShadow: `0 0 0 1px ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadiusLG,
      }}
    />
  );
};
